'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _conditionClassModifier = require('../helpers/conditionClassModifier');

var _conditionClassModifier2 = _interopRequireDefault(_conditionClassModifier);

var _conditionEnumToText = require('../helpers/conditionEnumToText');

var _conditionEnumToText2 = _interopRequireDefault(_conditionEnumToText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surfConditionsClass = function surfConditionsClass(conditions) {
  var classObject = {};
  classObject['quiver-surf-conditions'] = true;
  classObject['quiver-surf-conditions--' + (0, _conditionClassModifier2.default)(conditions)] = !!conditions;
  return (0, _classnames2.default)(classObject);
};

var SurfConditions = function SurfConditions(_ref) {
  var conditions = _ref.conditions,
      defaultCondition = _ref.defaultCondition;
  return _react2.default.createElement(
    'span',
    { className: surfConditionsClass(conditions) },
    (0, _conditionEnumToText2.default)(conditions) || defaultCondition
  );
};

SurfConditions.propTypes = {
  conditions: _propTypes2.default.string,
  defaultCondition: _propTypes2.default.string
};

SurfConditions.defaultProps = {
  conditions: null,
  defaultCondition: ''
};

exports.default = SurfConditions;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurfConditions/SurfConditions.js
// module id = 663
// module chunks = 11